var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFarDiagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 673.4 161",
    style: {
      enableBackground: "new 0 0 673.4 161"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#000000;stroke-width:0.5;stroke-miterlimit:10;}\n\t.st2{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:4.9281,2.9569;}\n\t.st3{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:5.1267,3.076;}\n\t.st4{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:5.0487,3.0292;}\n\t.st5{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:4.907,2.9442;}\n\t.st6{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;stroke-dasharray:5,3;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2_00000143595519064539289910000011565363229276390278_"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1_00000123416761457385262220000003551545545084690330_"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "9.1,119 9.1,107.6 126.4,31.6 195.4,60.4 195.4,70.8 78.7,145.9  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "9.1,107.6 78.2,135.9 195.4,60.4  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 78.7,
    y1: 145.9,
    x2: 78.2,
    y2: 135.9
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "283.3,137.3 400.3,61.7 400.3,39.7 366,26.3 248.6,102 248.6,123.6  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "321.5,152 319.4,153.4 317.1,152.4  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st2",
    x1: 314.4,
    y1: 151.2,
    x2: 286.9,
    y2: 139
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "285.5,138.4 283.3,137.3 285.4,136  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 287.9,
    y1: 134.3,
    x2: 396.9,
    y2: 63.9
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "398.2,63.1 400.3,61.7 402.6,62.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st4",
    x1: 405.4,
    y1: 63.7,
    x2: 434.1,
    y2: 74.8
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st0",
    points: "435.6,75.3 437.9,76.2 435.8,77.6  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st5",
    x1: 433.3,
    y1: 79.2,
    x2: 322.7,
    y2: 151.2
  }))), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "248.6,102 283.3,116.6 400.3,39.7  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "248.6,112.4 283.3,126.5 400.3,49.8  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 283.3,
    y1: 137.3,
    x2: 283.3,
    y2: 116.6
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "538.5,46.3 597.7,7 633.1,20.4 633.1,65.4 574.3,106.1 538.5,92.3  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st6",
    points: "538.5,92.3 479.2,128.1 548.2,156.4 668.5,80.3 633.1,65.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "538.5,46.3 573.9,60.7 633.1,20.4  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "538.5,56.5 573.9,71.2 633.1,32.2  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "538.5,67.6 573.9,81.9 633.1,43.8  "
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "st1",
    points: "538.5,78.9 573.9,93.1 633.1,54.3  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st1",
    x1: 573.9,
    y1: 60.7,
    x2: 573.9,
    y2: 104.3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarDiagram);
export default __webpack_public_path__ + "static/media/FAR_diagram.5973a3da22d04c712e098f49093a600f.svg";
export { ForwardRef as ReactComponent };